export default {
  notices: [],
  noticesCount: 0,
  query: '',
  limit: 10,
  skip: 0
}
